import React from 'react'
import {
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import Header from '../../components/liveroomLecturer/Header'
import {filterHTML} from "../../utils"
import config from '../../config'
import { browserHistory } from 'react-router'
import '../../css/page/ChannelEditPage.css'


class ChannelEditTitlePage extends React.Component {
    constructor (props) {
        super(props)
        this.type = /^\/lecture\//.test(props.location.pathname) ? 'lecture' : 'channel'
        this.state = {
            desc: '',
            isPending: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            channel: null
        }
    }
    componentDidMount () {
        this.fetchDesc()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    filterDesc (str) {
        return str.replace(/<style>.+?<\/style>/g, '')
    }
    fetchDesc () {
        this.setState({ isPending: true })
        axios.get(`/api/${this.type}/${this.props.params.id}/edit_info`)
            .then(res => {
                const desc = res.data.data[this.type].description
                this.setState({
                    desc: this.filterDesc(desc),
                    isPending: false,
                    channel: res.data.data.channel ? res.data.data.channel : null,
                    lecture: res.data.data.lecture ? res.data.data.lecture : null
                })
            })
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    onSubmit (e) {
        this.setState({ isPending: true })
        axios.post(`/api/${this.type}/${this.props.params.id}/edit`, qs.stringify({
            description: this.$edit.innerHTML,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('修改成功');

            })
    }
    onClickEdit (e) {
        this.$edit.focus()
    }
    onChangeFile (e) {
        if (!e.target.files[0]) {
            return
        }
        this.setState({ isPending: true })
        const formData = new FormData()
        formData.append('description', e.target.files[0])
        formData.append('target_id', this.props.params.id)
        formData.append('storage_type', 'lecture')
        axios.post('/api/upload_img', formData)
            .then(res => {
                this.setState({
                    isPending: false,
                })
                if (res.data.code) {
                    return alert(res.data.msg)
                }
                const $descClasses = document.querySelectorAll('.desc-class')
                if ($descClasses.length > 0) {
                    $descClasses[$descClasses.length - 1].innerHTML += `<img src='${res.data.data.img}' />`
                } else {
                    this.$edit.innerHTML += `<img src='${res.data.data.img}' />`
                }
            })
    }
    renderHeader() {
        if (this.state.lecture) {
            if (this.state.lecture.lecture_mode !== 'default') {
                if (this.state.lecture.lecture_type === 'pay_channel') {
                    return <Header title='课程讲稿' />
                }
            }
        }
        return <Header title='介绍内容' />
    }
    renderIntro() {
        if (this.state.lecture) {
            console.log('111')
            if (this.state.lecture.lecture_mode !== 'default') {
                if (this.state.lecture.lecture_type === 'pay_channel') {
                    return <p className="intro"><span className='red-star'>*</span> 当前课程为"必须购买专栏"的录播课，用户在购买后才能查看课程讲稿，可登录讲师管理后台（{config.ADMIN_BASE_URL}）"课程管理-编辑-封面与讲稿"进行编辑，效果更佳</p>
                }
            }else if (this.state.lecture.lecture_mode === 'default') {
                if (this.state.lecture.lecture_type === 'pay_channel') {
                    return <p className="intro"><span className='red-star'>*</span> 当前课程为"必须购买专栏"的直播课，用户购买专栏前不能访问单课介绍页，可以不编辑单课介绍，专注优化专栏介绍页即可</p>
                }
            }
        }
        return <p className="intro"><span className='red-star'>*</span> 更强大的编辑功能请登录讲师管理后台（{config.ADMIN_BASE_URL}）"课程管理-编辑-封面与介绍"进行操作，还有多款好看的模板助你快速创建吸引人的介绍内容</p>
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="desc-page">
                        {this.renderHeader()}
                        <div className='edit-wrap needsclick'>
                            <div className="header">
                                <div className="upload-img">
                                    <i className="iconfont icon-zhaopian"></i>
                                    <input type="file" onChange={e => this.onChangeFile(e)} />
                                </div>
                            </div>
                            <div
                                ref={r => this.$edit = r}
                                onClick={(e) => this.onClickEdit(e)}
                                className="edit-content needsclick"
                                contentEditable={true}
                                dangerouslySetInnerHTML={{__html: filterHTML(this.state.desc)}}
                            >
                            </div>
                        </div>
                        {this.renderIntro()}
                        <div className="wk-btn-90 padding-top-10">
                            <Button disabled={false} onClick={e => this.onSubmit(e)}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => browserHistory.go(-1) }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditTitlePage



// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditDescPage.js